import React, { useEffect, useState } from 'react';
import Footer from '../../shared/footer/Footer';
import LoginModal from '../../main/loginModal/LoginModal';
import Head from '../../Global/Head';
import Header from '../../Global/Header';
import { AiOutlineCalendar, AiOutlineShareAlt } from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { BsBookmark } from 'react-icons/bs';

export default function Blog5() {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(!!accessToken ? false : true);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - increment;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />

      <Header />
      <div className="max-w-7xl mx-auto p-6">
        <h1 className="text-4xl font-bold mt-4"> Building Hightable: Chaos, Coffee, and Co-founder Banter</h1>
        <div className="mt-4 flex items-start justify-between">
          <div className="flex items-center gap-4 text-sm text-gray-600">
           
            <div className="flex items-center gap-2">
              <span className="inline-block bg-black text-white px-2 py-0.5 rounded">HighTable</span>
            </div>
          </div>
         
        </div>

        <div className="mt-6 rounded-lg overflow-hidden">
          <img
            src="https://res.cloudinary.com/diecfwnp9/image/upload/v1761403965/IMG_0948_dq4pgl.jpg"
            alt="Where Women Rise Together"
            className="w-full h-64 sm:h-96 object-cover"
          />
        </div>

<div className="article-container mt-10">
      <section className="intro">
        <p>
          Startups are glamorous in Instagram posts and success stories—but the
          reality is often chaos wrapped in caffeine. That’s exactly how{" "}
          <strong>Hightable</strong> was built: with messy notebooks, endless
          coffee cups, and more debates than we can count.
        </p>
      </section>

      <hr />

      <section className="idea">
        <h2>The Idea That Sparked It All</h2>
        <p>
          Every startup begins with a spark. For me, it was the simple idea of
          connection. I noticed how much people crave belonging, yet often feel
          lost in both digital and physical spaces. From casual conversations
          with friends to deep reflections on my own experiences, the vision for{" "}
          <strong>Hightable</strong> slowly took shape: a platform where finding
          your tribe doesn’t feel forced, but natural.
        </p>
      </section>

      <hr />

      <section className="teamwork">
        <h2>Teamwork, Trials, and Late Nights</h2>
        <p>
          No journey is smooth. Building <strong>Hightable</strong> meant
          sleepless nights of coding, design, and strategy meetings. There were
          times when a single feature took weeks to perfect because we argued
          over every little detail—from the color of a button to the tone of
          notifications.
        </p>
        <p>
          And that’s the fun part: every debate, every banter with my
          co-founders, became a lesson in collaboration. It wasn’t about winning
          arguments—it was about building something we all believed in. The
          chaos was part of the magic.
        </p>
      </section>

      <hr />

      <section className="learning">
        <h2>Learning by Doing</h2>
        <p>
          <strong>Hightable</strong> wasn’t built in theory—it was built in
          action. We learned as we went: testing, failing, iterating, and
          sometimes scrapping entire ideas. Each mistake brought clarity, each
          success brought confidence. We realized early that adaptability and
          openness were just as important as any business plan.
        </p>
      </section>

      <hr />

      <section className="culture">
        <h2>Keeping the Culture Alive</h2>
        <p>
          Even in the busiest phases, we never let culture take a back seat.
          Every decision—whether product-related, hiring-related, or even
          deciding the snack list for office days—was informed by our core
          belief: authenticity and human connection matter above all.
        </p>
        <p>
          That culture shaped <strong>Hightable</strong> from the inside out.
          Because a product that helps people belong only works if the team
          building it truly embodies belonging themselves.
        </p>
      </section>

      <hr />

      <section className="moments">
        <h2>Moments That Made It Worthwhile</h2>
        <p>
          Amidst the chaos were small, unforgettable moments: celebrating a
          first user milestone with cupcakes, a 2 AM breakthrough on a tricky
          feature, or laughing uncontrollably at a ridiculous bug that crashed
          the app. These moments are what make the journey real and
          unforgettable.
        </p>
      </section>

      <hr />

      <section className="takeaway">
        <h2>The Takeaway</h2>
        <p>
          Building <strong>Hightable</strong> has been messy, loud, exhausting—
          and incredibly rewarding. From the early spark of an idea to a
          platform that’s now connecting real people, the journey taught us that
          chaos, coffee, and collaboration are not obstacles—they are the
          ingredients of creation.
        </p>
        <p>
          <strong>Hightable</strong> isn’t just an app; it’s the story of a team
          daring to make connection feel human again. And the journey has just
          begun.
        </p>
      </section>
    </div>
      </div>
      <Footer />
    </div>
  );
}
